import OrderObj from "../features/orders/orderObj";

export default class AuthNetAPI {
  static async capturePayment(
    token: string,
    nonce: string,
    order: OrderObj
  ) {
    let response = await(fetch(
      process.env.REACT_APP_SERVER_URL + '/authorize_net',
      {
        method: 'POST',
        headers: { 'content-type': 'application/json;charset=UTF-8' },
        body: JSON.stringify({
          token: token,
          nonce: nonce,
          order: order.data
        })
      }
    ));
    if (!response.ok) {
      console.error('HTTP error while capturing payment:', response);
      throw new Error(`HTTP error. status: ${response.status}`);
    }
    return await response.json();
  }
}